module.exports = __webpack_public_path__ + "static/media/ruler.f010a2f0.svg";